export default function Reading() {
  return (
    <div class="text-gray-600 body-font">
      <div class="flex flex-col text-center w-full mb-5">
        <h1 class="text-4xl font-bold title-font mb-4 text-rose-400">
          READING
        </h1>
        <p class="lg:w-2/3 mx-auto leading-relaxed text-rose-400">
          Words impact us in more ways than we can imagine. It's important to
          consume good content, which helps us grow! <br />
          The following articles are excerpts from some self help books, curated
          specially for you!
        </p>
      </div>
      <br />
      <div className="bg-cyan-50">
        <h1 class="text-4xl font-bold title-font mb-4 text-cyan-400">
          When you feel lost and alone:
        </h1>
      </div>
      <div class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 py-10 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              3 Little Reminders That Will Make You Feel Way Less Alone
            </h1>
            <p class="mb-8 leading-relaxed">
              <b>
                1. Every passing face on the street represents a story every bit
                as captivating, complicated, and crazy as yours.
              </b>
              <br />
              Remember that everyone has a story. Everyone has gone through
              something that’s unexpectedly changed them and forced them to
              grow. Everyone you meet has struggled, and continues to struggle
              in some way, and to them, it’s just as hard as what you’re going
              through.
              <br />
              <b>2. You are far more than that one broken piece of you.</b>
              <br />
              When times are tough, and some piece of you is chipped and broken,
              it’s easy to feel like everything—all of you—is broken along with
              it. But that’s not true. We all have this picture in our minds of
              ourselves—this idea of what kind of person we are. When this idea
              gets even slightly harmed or threatened, we react defensively and
              oftentimes irrationally. But the craziest thing is, oftentimes we
              are actually the ones harming and threatening ourselves with
              negativity and false accusations.
              <br />
              <b>
                3. There are people in this world who desperately need your
                support right now.
              </b>
              <br />
              We all have the tendency to put ourselves at the center of the
              universe and to see everything from the viewpoint of how it
              affects us.So whenever we catch ourselves lingering at the center
              in an adverse state of mind, we do our best to briefly shift our
              focus away from our own issues and onto other people around us
              that we might be able to help.
              <br />
              <b>Closing Thoughts:</b>
              <br /> So please try to smile more often. Even when times are
              hard, you have so many reasons to. Time and time again, our reason
              is you. You won’t always be perfect, and neither will we. Because
              nobody is perfect, and nobody deserves to be perfect. Everybody
              has issues. Nobody has it easy. You will never know exactly what
              we’re going through, and we will never know exactly what you’re
              going through. We are all fighting our own unique war.
            </p>
          </div>
          <p class="mb-8 leading-relaxed"> </p>
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="/book1.png"
            />
          </div>
        </div>
        <br />
      <div className="bg-cyan-50">
        <h1 class="text-4xl font-bold title-font mb-4 text-cyan-400">
          When you feel ovewhelmed:
        </h1>
      </div>
      <div class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 py-10 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Small changes can transform your life
            </h1>
            <p class="mb-8 leading-relaxed">
            It is so easy to overestimate the importance of one defining moment and underestimate the value of making small improvements on a daily basis. Too often, we convince ourselves that massive success requires massive action. Whether it is losing weight, building a business, writ­ing a book, winning a championship, or achieving any other goal, we put pressure on ourselves to make some earth-shattering improvement that everyone will talk about.
              <br />
              Meanwhile, improving by 1 percent isn’t particularly notable—sometimes it isn’t even noticeable—but it can be far more meaningful, especially in the long run. The difference a tiny improvement can make over time is astounding. Here’s how the math works out: if you can get 1 percent better each day for one year, you’ll end up thirty-seven times better by the time you’re done. Conversely, if you get 1 percent worse each day for one year, you’ll decline nearly down to zero. What starts as a small win or a minor setback accumulates into something much more.
              <br />
              Habits are the compound interest of self-improvement. The same way that money multiplies through compound interest, the effects of your habits multiply as you repeat them. They seem to make little dif­ference on any given day and yet the impact they deliver over the months and years can be enormous. It is only when looking back two, five, or perhaps ten years later that the value of good habits and the cost of bad ones becomes strikingly apparent.
              <br />
              Your outcomes are a lagging measure of your habits. Your net worth is a lagging measure of your financial habits. Your weight is a lagging measure of your eating habits. Your knowledge is a lagging measure of your learning habits. Your clutter is a lagging measure of your cleaning habits. You get what you repeat.<br/>
              Habits are a double-edged sword. Bad habits can cut you down just as easily as good habits can build you up, which is why understanding the details is crucial. You need to know how habits work and how to design them to your liking, so you can avoid the dangerous half of the blade.


            </p>
          </div>
          <p class="mb-8 leading-relaxed"> </p>
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="/atomic.jpg"
            />
          </div>
        </div>
        </div>
      </div>
      <br />
      <div className="bg-cyan-50">
        <h1 class="text-4xl font-bold title-font mb-4 text-cyan-400">
          When you are doubting yourself:
        </h1>
      </div>
      <div class="text-gray-600 body-font">
        <div class="container mx-auto flex px-5 py-10 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
              Letting go of self-doubt
            </h1>
            <p class="mb-8 leading-relaxed">
            Self-doubt undermines the process of finding our gifts and sharing them with
the world. Moreover, if developing and sharing our gifts is how we honor spirit
and connect with God, self-doubt is letting our fear undermine our faith. To overcome self-doubt and “supposed to,” we have to start owning the
messages. What makes us afraid? What’s on our “supposed to” list? Who says?
Why?

              <br />
              Gremlins are like toddlers. If you ignore them, they get louder. It’s usually
best to just acknowledge the messages. Write them down. I know it seems
counterintuitive, but writing them down and owning the gremlins’ messages
doesn’t give the messages more power; it gives us more power. It gives us the
opportunity to say, “I get it. I see that I’m afraid of this, but I’m going to do it
anyway.
              <br />
              In addition to the gremlins, another thing that gets in the way of meaningful work
is the struggle to define who we are and what we do in an honest way. In a
world that values the primacy of work, the most common question that we ask
and get asked is, “What do you do?” I used to wince every time someone asked
me this question. I felt like my choices were to reduce myself to an easily
digestible sound bite or to confuse the hell out of people.It’s always been one of my favorites, but now that I’ve
studied the importance of meaningful work, it’s taken on new significance:
“Don’t ask what the world needs. Ask what makes you come alive, and go do it.
Because what the world needs is people who have come alive.”
              <br />
              Get Deliberate: It can take some time to figure out how to get deliberate about
doing meaningful work.<br/>
Get Inspired: Read and consume content that inspires you, frees you from stigma.
<br/>
Get Going: Make a list of the work that inspires you. Don’t be practical. Don’t
think about making a living; think about doing something you love. There’s
nothing that says you have to quit your day job to cultivate meaningful work

            </p>
          </div>
          <p class="mb-8 leading-relaxed"> </p>
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="/book3.jpg"
            />
          </div>
        </div>
        </div>
      </div>
    
  );
}
